module.exports = __webpack_public_path__ + "static/media/2.923a1fe2.jpg";